export default "__VITE_ASSET__b8372e68__"